var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWomenswear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Dress-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dress 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.46 7.8a0.51 0.51 0 0 0 0.42 0.43 25.93 25.93 0 0 0 4.12 0.35 26 26 0 0 0 4.12 -0.35 0.51 0.51 0 0 0 0.42 -0.43c0.05 -0.34 0.05 -0.28 1.14 -6.33a1 1 0 0 0 -0.75 -1.15L15.75 0a1 1 0 0 0 -1.17 0.63l-0.65 2a0.53 0.53 0 0 1 -0.47 0.35l-2.9 0a0.48 0.48 0 0 1 -0.48 -0.34L9.41 0.62A1 1 0 0 0 8.25 0L7.07 0.32a1 1 0 0 0 -0.75 1.15C7.5 8 7.42 7.48 7.46 7.8Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.92 20.51 -4 -9.17a5 5 0 0 1 -0.2 -0.69 0.5 0.5 0 0 0 -0.57 -0.38 23.72 23.72 0 0 1 -4.11 0.35 23.72 23.72 0 0 1 -4.11 -0.35 0.51 0.51 0 0 0 -0.57 0.38c-0.05 0.22 -0.11 0.44 -0.18 0.65l-4.1 9.21a1.49 1.49 0 0 0 0.81 1.84A21.38 21.38 0 0 0 12 24a21.38 21.38 0 0 0 8.11 -1.65 1.49 1.49 0 0 0 0.81 -1.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWomenswear);
export default ForwardRef;